import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { RenderField, RenderTextareaField, RenderSubmitButton } from '../../../common/form';
import * as Validations from '../../../common/form/commonValidations';
import { addHomepageSection, updateHomepageSection } from '../../../../actions/website/entities/HomepageSectionActions';
import { hideModal } from '../../../../actions/ModalActions';

let HomepageSectionForm = (props) => {
  const { handleSubmit, pristine, submitting, valid, isUpdate } = props;
  return (
    <div className="entity-form">
      <div className="modal-header">
        <h3 className="modal-title">{isUpdate ? 'Edit' : 'Add'} Story</h3>
      </div>
      <div className="modal-body">
        <form onSubmit={handleSubmit} noValidate>
          <Field
            name="title"
            id="homepage-section-form-title"
            label="Title"
            placeholder="How We Met"
            type="text"
            component={RenderField}
            maxChars={60}
            required
            validate={[Validations.REQUIRED, Validations.MAX_LENGTH_60]}
          />
          <Field
            name="subtitle"
            id="homepage-section-form-subtitle"
            label="Tagline or Date"
            placeholder="First comes school, then comes marriage."
            type="text"
            component={RenderField}
            validate={Validations.MAX_LENGTH_200}
            maxChars={200}
          />
          <Field
            name="description"
            id="homepage-section-form-description"
            label="Description"
            placeholder="We met at a classmate's party and didn't think much of it. Then a bunch of us went to karaoke after a long day of back-to-back classes and we both picked, &quot;I'd Do Anything for Love.&quot; And it just clicked. He went low, I went high. There were fist pumps. We harmonized by accident. That's pretty much when we thought, &quot;Okay. This could be something.&quot;"
            component={RenderTextareaField}
            required
            validate={[Validations.REQUIRED, Validations.MAX_LENGTH_2000]}
            rows={5}
            maxChars={2000}
          />
          <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid} />
        </form>
      </div>
    </div>
  );
};

HomepageSectionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  isUpdate: PropTypes.bool
};

HomepageSectionForm = reduxForm({
  form: 'homepageSectionForm'
})(HomepageSectionForm);

const mapStateToProps = state => ({
  initialValues: state.website.entities.byId[state.website.entities.selectedEntityId]
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (homepageSectionFormRequest) => {
    if (homepageSectionFormRequest.id) {
      dispatch(updateHomepageSection(homepageSectionFormRequest));
    } else {
      dispatch(addHomepageSection(homepageSectionFormRequest));
    }
    dispatch(hideModal());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomepageSectionForm);



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/HomepageSectionForm.jsx